import { call, put, takeLatest } from 'redux-saga/effects';
import api from 'api/api';
import { logError } from 'utils/logger';
import types from '../types';

function* getTeamApp({ payload }) {
  try {
    const { status, data } = yield call(api.teams.getTeamAppData, payload);

    if (status < 200 || status >= 300) {
      logError('Team App API returned error status', {
        status,
        teamId: payload,
      });
      yield put({
        type: types.GET_TEAM_APP_ERROR,
        payload: 'Something went wrong. Please try again later',
      });
    } else {
      // getAllAppsAndSites returns an array, get the first item
      const teamAppData = Array.isArray(data) ? data[0] : data;

      yield put({
        type: types.GET_TEAM_APP_SUCCESS,
        payload: teamAppData,
      });
    }
  } catch (error) {
    logError('Team App API Error', error, { teamId: payload });
    yield put({
      type: types.GET_TEAM_APP_ERROR,
      payload: 'Something went wrong. Please try again later',
    });
  }
}

export function* teamAppWatcher() {
  yield takeLatest(types.GET_TEAM_APP_START, getTeamApp);
}
